export default __webpack_public_path__ + "static/media/RCBC_PERSONAL.4427819a.svg";